import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { ASSET_NAME } from '../../../app.consts';
import { ApplicationService } from '../../../services/application-service';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { FlowService } from '../../../services/flow.service';
import { ApplicationScoreService } from 'creddo-shared-library';

@Component({
  selector: 'app-accounting-upload',
  templateUrl: './accounting-upload.component.html',
  styleUrls: ['./accounting-upload.component.scss'],
})
export class AccountingUploadComponent implements OnInit, OnDestroy {
  applicationId!: number;
  accountingUploadForm!: FormGroup;
  error!: string;
  locale!: string;
  assetName!: typeof ASSET_NAME;
  subs: Array<Subscription> = [];
  @Input() isSummary!: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private applicationService: ApplicationService,
    public flowService: FlowService,
    private applicationScoreService: ApplicationScoreService
  ) {}

  ngOnInit(): void {
    this.applicationId = this.applicationService.applicationId;
    const initialBalance = this.applicationService.balance || [];
    const initialProfitAndLoss = this.applicationService.profitAndLoss || [];

    this.accountingUploadForm = this.formBuilder.group({
      balance: this.formBuilder.array(initialBalance),
      profitAndLoss: this.formBuilder.array(initialProfitAndLoss),
    });
    this.assetName = ASSET_NAME;

    this.subs.push(
      this.balance.valueChanges.pipe(debounceTime(200)).subscribe((v) => {
        this.applicationService.balance = v;
        this.applicationScoreService.updateAppScore(
          'balancesheet', 
          Object.keys(v).length !== 0 ? true : false
        );
      })
    );
    this.subs.push(
      this.profitAndLoss.valueChanges.pipe(debounceTime(200)).subscribe((v) => {
        this.applicationService.profitAndLoss = v;
        this.applicationScoreService.updateAppScore(
          'profitandloss', 
          Object.keys(v).length !== 0 ? true : false
        );
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.map((sub) => sub.unsubscribe());
  }

  handleBackButtonClick(): void {
    this.flowService.previousScreen();
  }

  handleNextButtonClick(): void {
    this.flowService.nextScreen();
  }

  get form(): FormGroup {
    return this.accountingUploadForm;
  }

  get balance(): FormArray {
    return this.form.get('balance') as FormArray;
  }

  get profitAndLoss(): FormArray {
    return this.form.get('profitAndLoss') as FormArray;
  }
}
